import styled, { css } from 'styled-components';

interface BadgeProps {
  bgColor?: string;
  bgColorHover?: string;
  txtColor?: string;
  marginBottom?: number;
  small?: boolean;
}

export const Badge = styled.div<BadgeProps>`
  min-height: ${({ small }) => (small ? '18px' : '24px')};
  padding: 3px 10px;
  background-color: ${({ theme, bgColor }) => bgColor ?? theme.kashmirBlue};
  border-radius: 6px;
  font-weight: 600;
  font-size: 10px;
  display: inline-flex;
  color: ${({ theme, txtColor }) => txtColor ?? theme.white};
  margin-bottom: ${({ marginBottom }) => marginBottom ?? '0'}px;
  transition: background-color 300ms ease;
  align-items: center;
  gap: 8px;
  ${({ bgColorHover }) =>
    bgColorHover &&
    css`
      &:hover {
        background-color: ${bgColorHover};
      }
    `}
`;
